import React from "react";
import { Box, Card, CardHeader, Divider, Typography } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import NoDataCard from "./NoDataCard";
import CardSkeleton from "./CardSkeleton";

const MetricCard = ({
  title,
  icon,
  iconBackground = "#EEF4FF",
  iconColor = "#2878DF",
  metrics = [],
  onViewDetails,
  loading,
}) => {
  const hasMetrics = !!metrics && metrics.length > 0;

  if (loading) {
    return <CardSkeleton height={300} />;
  }

  if (!hasMetrics) {
    return <NoDataCard title={title} />;
  }

  return (
    <Card style={{ border: "1px solid #E5E7EB", borderRadius: 10, backgroundColor: "#FFFFFF", overflow: "hidden", boxShadow: "0 4px 18px rgba(15, 23, 42, 0.05)", height: 300, display: "flex", flexDirection: "column" }} elevation={1}>
      {/* Header */}
      <CardHeader
        disableTypography
        style={{ padding: "14px 18px" }}
        title={
          <Box display="flex" alignItems="center">
            <Box width={30} height={30} display="flex" alignItems="center" justifyContent="center" mr={1} style={{ backgroundColor: iconBackground, borderRadius: 8 }} >
              {icon &&
                React.cloneElement(icon, {
                  style: { fontSize: 17, color: iconColor },
                })}
            </Box>

            <Typography style={{ fontSize: 15, fontWeight: 700, color: "#202838" }}>
              {title}
            </Typography>

            <InfoOutlinedIcon style={{ fontSize: 15, color: "#91A0B6", marginLeft: 7 }} />
          </Box>
        }
        action={
          onViewDetails ? (
            <Box
              display="flex"
              alignItems="center"
              style={{ cursor: "pointer" }}
              onClick={onViewDetails}
            >
              <Typography style={{ fontSize: 12.5, fontWeight: 600, color: "#2878DF" }}>
                View details
              </Typography>

              <ArrowForwardIosIcon style={{ fontSize: 11, color: "#2878DF", marginLeft: 5 }} />
            </Box>
          ) : null
        }
      />

      <Divider />

      {/* Content */}
      <Box px={2} style={{ flex: 1, overflowY: "auto" }}>
        {metrics.map((metric, index) => {
          const hasValue = metric.value !== null && metric.value !== undefined && metric.value !== "";

          return (
            <Box
              key={metric.key || metric.label || index}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              py={1.15}
              style={{
                borderBottom: index === metrics.length - 1 ? "none" : "1px solid #E8EBF0",
              }}
            >
              {/* Label */}
              <Typography style={{ fontSize: 13.5, fontWeight: 500, color: "#65718A", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", paddingRight: 8, }} >
                {metric.label}
              </Typography>

              {/* Value */}
              <Box display="flex" alignItems="center" justifyContent="flex-end" ml={1}>
                {hasValue ? (
                  <Typography
                    style={{
                      fontSize: 13.5,
                      fontWeight: 700,
                      color: typeof metric.color === "function" ? metric.color(metric.value) : metric.color || "#202838",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {metric.format ? metric.format(metric.value) : metric.value}

                    {metric.unit && (
                      <span style={{ fontWeight: 600, marginLeft: 3 }}>{metric.unit}</span>
                    )}
                  </Typography>
                ) : (
                  <Box display="flex" alignItems="center" style={{ whiteSpace: "nowrap" }}>
                    <Typography style={{ fontSize: 13, fontWeight: 600, color: "#9AA4B5" }}> — </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Card>
  );
};

export default MetricCard;
